<div class="error-page">
  <h1 class="error-page-title">
    You don't have permission to access the USAS Portal. To request access, please contact the <a target="_blank" href="https://jira.faa.gov/servicedesk/customer/portal/70/create/1902">USAS Service Desk</a> or e-mail <a href="mailto:APP-AIT-USAS@faa.gov">APP-AIT-USAS&#64;faa.gov</a>.
  </h1>
</div>